import * as React from 'react';
import Card from "@mui/material/Card";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({theme}) => ({
    height: '100%',
    boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
    '& .MuiCardHeader-root': {
        borderBottom: 'none',
        paddingBottom: '0',
        '& .MuiCardHeader-title':{
            fontWeight: 600,
            fontSize: '1rem',
            border: 'none',
        },
        '& .MuiCardHeader-subheader': {
            fontSize: '0.85rem',
            marginTop: '0.25rem',
            color: theme.palette.secondary.main,
        },
    },
    '& .MuiCardContent-root':{
        '& .MuiList-root':{
            padding: 0,
            '& .MuiListItem-root':{
                borderBottom: `1px dashed ${theme.palette.divider}`,
                '&:last-child':{
                    borderBottom: 'none',
                }
            }
        },
        '& .MuiTableContainer-root': {
            border: 'none',
            boxShadow: 'none',
            '& .MuiTable-root': {
                '& .MuiTableHead-root': {
                    '& .MuiTableCell-root': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: theme.spacing(1, 2),
                    }
                },
                '& .MuiTableRow-root': {
                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                        '& .MuiTableCell-root': {
                            transition: 'color 0.3s ease',
                            color: theme.palette.primary.main,
                        }
                    },
                    '&:last-child td, &:last-child th': {
                        borderBottom: 'none',
                    }
                }
            },
            '& .MuiTableCell-root': {
                fontSize: '0.875rem',
                '& .MuiTypography-root': {
                    fontSize: '0.875rem',
                }
            },
            '& .MuiTableRow-root': {
                '&:last-child td, &:last-child th': {
                    borderBottom: 'none',
                }
            }
        }
    },
    '& .MuiCardActions-root': {
        borderTop: 'none',
    }
}));

export const Panel = ({children, ...params}) => {

    return (
        <StyledCard {...params}>
            {children}
        </StyledCard>
    );
}

